import { render, staticRenderFns } from "./MicrosoftQuotations.vue?vue&type=template&id=28b671b8&scoped=true&"
import script from "./MicrosoftQuotations.vue?vue&type=script&lang=js&"
export * from "./MicrosoftQuotations.vue?vue&type=script&lang=js&"
import style0 from "./MicrosoftQuotations.vue?vue&type=style&index=0&id=28b671b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b671b8",
  null
  
)

export default component.exports